import { viewerApi } from '@viewer/lib/viewerApi'
import type { Camara } from './desenhoDeCorte'

/** A câmara do viewer na forma que o desenho da caixa e dos planos quer. */
export function camaraDoViewer(): Camara | null {
  const world = viewerApi.getWorld()
  if (!world) return null
  const cam = world.camera.three
  cam.updateMatrixWorld()
  const canvas = world.renderer!.three.domElement
  return {
    vista: cam.matrixWorldInverse.elements,
    projeccao: cam.projectionMatrix.elements,
    largura: canvas.clientWidth,
    altura: canvas.clientHeight,
  }
}
